import { render, staticRenderFns } from "./LotTable.vue?vue&type=template&id=ef843a1c"
import script from "./LotTable.vue?vue&type=script&lang=js"
export * from "./LotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports